"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableFetcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var lodash_1 = require("lodash");
var infinite_1 = tslib_1.__importDefault(require("swr/infinite"));
var types_1 = require("../types");
var utils_1 = require("../utils");
var useTableFetcher = function (url, defaultSort, httpClientGet, getKey, limit, router, fetcherProps, onHasFilter, filters) {
    if (defaultSort === void 0) { defaultSort = null; }
    var defaultURL = url && new URL(url);
    if (defaultURL && defaultSort) {
        var order = defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.map(function (sort) {
            if ((sort === null || sort === void 0 ? void 0 : sort.order) === types_1.ORDERING.DESC) {
                return "-".concat(sort.key);
            }
            return sort.key;
        }).toString();
        defaultURL.searchParams.set("ordering", order);
    }
    if (defaultURL && limit) {
        defaultURL.searchParams.set("page_size", String(limit));
    }
    var _a = (0, react_1.useState)(defaultURL), fetchURL = _a[0], setFetchURL = _a[1];
    var _b = (0, infinite_1.default)(getKey(url && fetchURL.toString()), httpClientGet, tslib_1.__assign({ revalidateFirstPage: false }, fetcherProps)), data = _b.data, error = _b.error, mutate = _b.mutate, size = _b.size, setSize = _b.setSize;
    var hasMore = !(0, lodash_1.isEmpty)((0, lodash_1.get)((0, lodash_1.last)(data), "cursors.next"));
    var count = (0, lodash_1.get)((0, lodash_1.last)(data), "count");
    var loading = (data === null || data === void 0 ? void 0 : data.length) != size && error === undefined;
    var handler = (0, react_1.useMemo)(function () { return ({
        paginate: function () {
            setSize(function (x) { return x + 1; });
        },
        search: function (val, addToURL) {
            if (addToURL === void 0) { addToURL = true; }
            if ((0, lodash_1.trim)(val)) {
                fetchURL && fetchURL.searchParams.set("search", val);
                setFetchURL(new URL(fetchURL.toString()));
                if (addToURL) {
                    (0, utils_1.applyFiltersToURL)("search", val, router);
                }
            }
        },
        multipleSort: function (sort_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return tslib_1.__awaiter(void 0, tslib_1.__spreadArray([sort_1], args_1, true), void 0, function (sort, addToURL) {
                var ordering;
                if (addToURL === void 0) { addToURL = true; }
                return tslib_1.__generator(this, function (_a) {
                    ordering = sort.map(function (row) {
                        return row.order === types_1.ORDERING.DESC ? "-".concat(row.key) : row.key;
                    });
                    fetchURL && fetchURL.searchParams.set("ordering", ordering.toString() + ",id");
                    setFetchURL(new URL(fetchURL.toString()));
                    if (addToURL) {
                        if (ordering.toString()) {
                            (0, utils_1.applyFiltersToURL)("sort", ordering.toString(), router);
                        }
                        else {
                            (0, utils_1.removeFiltersFromURL)(["sort"], router);
                        }
                    }
                    return [2 /*return*/];
                });
            });
        },
        filter: function (key_1, condition_1, val_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return tslib_1.__awaiter(void 0, tslib_1.__spreadArray([key_1, condition_1, val_1], args_1, true), void 0, function (key, condition, val, addToURL, isDate) {
                var modifyFilter, modifiedFilter, filterValue, exits;
                var _a;
                if (addToURL === void 0) { addToURL = true; }
                if (isDate === void 0) { isDate = false; }
                return tslib_1.__generator(this, function (_b) {
                    modifyFilter = (_a = filters === null || filters === void 0 ? void 0 : filters.find(function (filter) { return filter.key === key; })) === null || _a === void 0 ? void 0 : _a.modifyFilter;
                    if (modifyFilter && fetchURL) {
                        modifiedFilter = modifyFilter(key, val, condition);
                        filterValue = fetchURL.searchParams.get(modifiedFilter.key);
                        exits = filterValue === null || filterValue === void 0 ? void 0 : filterValue.includes(modifiedFilter.value);
                        if (!exits) {
                            fetchURL.searchParams.set(modifiedFilter.key, filterValue ? "".concat(filterValue, ",").concat(modifiedFilter.value) : modifiedFilter.value);
                            setFetchURL(new URL(fetchURL.toString()));
                            if (addToURL) {
                                (0, utils_1.applyFiltersToURL)(key.concat(condition), val, router);
                            }
                        }
                    }
                    else {
                        if (isDate) {
                            val.map(function (v) {
                                fetchURL && fetchURL.searchParams.set(key.concat(v.condition), v.value);
                            });
                            setFetchURL(new URL(fetchURL.toString()));
                            if (addToURL) {
                                (0, utils_1.applyDateFiltersToURL)(key, val, router);
                            }
                        }
                        else {
                            fetchURL && fetchURL.searchParams.set(key.concat(condition), val);
                            setFetchURL(new URL(fetchURL.toString()));
                            if (addToURL) {
                                (0, utils_1.applyFiltersToURL)(key.concat(condition), val, router);
                            }
                        }
                    }
                    return [2 /*return*/];
                });
            });
        },
        removeFilter: function (key, all) {
            var _a;
            if (all === void 0) { all = false; }
            var removeByKeyInValue = (_a = filters === null || filters === void 0 ? void 0 : filters.find(function (filter) { return filter.key === key; })) === null || _a === void 0 ? void 0 : _a.removeByKeyInValue;
            if (removeByKeyInValue) {
                if (fetchURL) {
                    var filterValue = fetchURL.searchParams.get(removeByKeyInValue);
                    var values = filterValue === null || filterValue === void 0 ? void 0 : filterValue.split(",").filter(function (value) { return !(value === null || value === void 0 ? void 0 : value.startsWith(key.toString())); }); // configurable
                    if (values) {
                        fetchURL.searchParams.set(removeByKeyInValue, (0, lodash_1.join)(values, ","));
                    }
                    else {
                        fetchURL.searchParams.delete(removeByKeyInValue);
                    }
                    setFetchURL(new URL(fetchURL.toString()));
                    if (typeof key === "string") {
                        (0, utils_1.removeFiltersFromURL)([key], router);
                    }
                    else {
                        (0, utils_1.removeFiltersFromURL)(key, router);
                    }
                }
            }
            else {
                if (all) {
                    setFetchURL(new URL(defaultURL.toString()));
                    return;
                }
                var keys_1 = [];
                // get all associated keys
                if (fetchURL) {
                    if ((0, lodash_1.isArray)(key)) {
                        (0, utils_1.removeFiltersFromURL)(key, router);
                        key.forEach(function (k) { return fetchURL.searchParams.delete(k); });
                        setFetchURL(new URL(fetchURL.toString()));
                        return;
                    }
                    fetchURL.searchParams.forEach(function (_, k) {
                        if (k.startsWith(key)) {
                            keys_1.push(k);
                        }
                    });
                    keys_1.forEach(function (k) { return fetchURL.searchParams.delete(k); });
                    setFetchURL(new URL(fetchURL.toString()));
                    if (!(0, lodash_1.isEmpty)(keys_1)) {
                        (0, utils_1.removeFiltersFromURL)(keys_1, router);
                    }
                }
            }
        },
    }); }, [defaultURL, fetchURL, setSize]);
    var hasFilter = onHasFilter ? onHasFilter(fetchURL) : false;
    return { loading: loading, hasMore: hasMore, count: count, data: data, hasFilter: hasFilter, mutate: mutate, handler: handler, fetchURL: fetchURL };
};
exports.useTableFetcher = useTableFetcher;
//# sourceMappingURL=fetcher.js.map